import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useTranslation } from 'react-i18next';
import FileDownload from 'js-file-download';

interface TokenDownloadButtonProps {
  token: string;
  appId: string;
  tabIndex?: number;
}

export const TokenDownloadButton = ({
  token,
  appId,
  tabIndex,
}: TokenDownloadButtonProps) => {
  const { t } = useTranslation();
  const disabled = !token?.trim();

  return (
    <Tooltip title={t('tooltipDownloadToken')}>
      <span>
        <IconButton
          size="small"
          color="primary"
          aria-label={t('tooltipDownloadToken')}
          disabled={disabled}
          tabIndex={tabIndex}
          sx={{ width: 28, height: 28, flexShrink: 0 }}
          onClick={(event) => {
            event.stopPropagation();
            if (!disabled) {
              FileDownload(
                token,
                `token_${appId}.txt`,
                'text/plain;charset=utf-8'
              );
            }
          }}
        >
          <FileDownloadOutlinedIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
};

TokenDownloadButton.defaultProps = {
  tabIndex: 0,
};
